import { render, staticRenderFns } from "./scoringRubric.vue?vue&type=template&id=78a631e1&scoped=true"
import script from "./scoringRubric.vue?vue&type=script&lang=js"
export * from "./scoringRubric.vue?vue&type=script&lang=js"
import style0 from "./scoringRubric.vue?vue&type=style&index=0&id=78a631e1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a631e1",
  null
  
)

export default component.exports